'use client';

import { useAriaLabels } from '@/hooks/useAriaLabels';

import type { BreadcrumbsSkeletonComponentProps } from './Breadcrumbs.shared';
import styles from '../Breadcrumbs.module.scss';

/**
 * Skeleton loader for breadcrumbs.
 * Use in loading.tsx or Suspense boundaries to prevent layout shift.
 */
export const BreadcrumbsSkeleton = ({
  className,
  testId = 'Breadcrumbs',
}: BreadcrumbsSkeletonComponentProps) => {
  const aria = useAriaLabels();

  return (
    <nav
      className={`${styles.wrapper} ${className || ''}`}
      aria-label={aria.action('breadcrumbLoading')}
      aria-busy="true"
      data-testid={testId}
    >
      <div className={styles.skeleton}>
        <div className={styles.skeletonItem} style={{ width: '40px' }} />
        <span className={styles.skeletonChevron} />
        <div className={styles.skeletonItem} style={{ width: '60px' }} />
        <span className={styles.skeletonChevron} />
        <div className={styles.skeletonItem} style={{ width: '80px' }} />
      </div>
    </nav>
  );
};

BreadcrumbsSkeleton.displayName = 'BreadcrumbsSkeleton';
